import { useEffect, type ComponentType } from "react"
import { useRouter } from "next/navigation"

import { useAppSelector } from "@/lib/hooks"
import { getContinueWith } from "../utils/url"

const withAnonymousRoute = <P extends object>(Component: ComponentType<P>) => {
  const AnonymousRoute = (props: P) => {
    const auth = useAppSelector((state) => state.auth)
    const authPayload = useAppSelector((state) => state.authPayload)
    const router = useRouter()
    const to = getContinueWith() || "/home/"
    const shouldRedirect = Boolean(auth) && !authPayload

    useEffect(() => {
      if (shouldRedirect) {
        console.log("you are in an anonymous route with user. we forward you to: ", window.location.href, to)
        router.replace(to)
      }
    }, [shouldRedirect, router, to])

    if (shouldRedirect) {
      console.error("user with auth in anonymous routes", window.location.href, to)
      return null
    }

    return <Component {...props} />
  }
  AnonymousRoute.displayName = `withAnonymousRoute(${Component.displayName || Component.name || "Component"})`
  return AnonymousRoute
}

export default withAnonymousRoute
